const textAreaMaxLength = 300;
export default textAreaMaxLength;
